/**
 * URL 판별 유틸리티
 *
 * 링크 노드 분류 시 비디오/유튜브 여부 판단에 사용된다.
 */

import { videoExtensions } from '@/entities/block/lib/blockTextPatterns';

const youtubeEmbedPattern = /youtube\.com\/embed\/([a-zA-Z0-9_-]+)/;
const youtubeWatchPattern = /youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/;
const youtubeShortPattern = /youtu\.be\/([a-zA-Z0-9_-]+)/;
const youtubeShortsPattern = /youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/;

/**
 * URL이 비디오 확장자로 끝나는지 확인
 */
export const isVideoUrl = (url: string): boolean => {
  const baseUrl = url.toLowerCase().split('?')[0];
  return videoExtensions.some((ext) => baseUrl.endsWith(`.${ext}`));
};

/**
 * YouTube URL에서 videoId 추출
 * - youtube.com/embed/VIDEO_ID
 * - youtube.com/watch?v=VIDEO_ID
 * - youtu.be/VIDEO_ID
 */
export const extractYoutubeVideoId = (url: string): string | undefined => {
  const match =
    url.match(youtubeEmbedPattern) ??
    url.match(youtubeWatchPattern) ??
    url.match(youtubeShortPattern) ??
    url.match(youtubeShortsPattern);
  return match?.[1];
};

/**
 * URL이 YouTube URL인지 확인
 */
export const isYoutubeUrl = (url: string): boolean => {
  return extractYoutubeVideoId(url) !== undefined;
};
